import { render, staticRenderFns } from "./Flow_list.vue?vue&type=template&id=396234e8&scoped=true"
import script from "./Flow_list.vue?vue&type=script&lang=js"
export * from "./Flow_list.vue?vue&type=script&lang=js"
import style0 from "./Flow_list.vue?vue&type=style&index=0&id=396234e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396234e8",
  null
  
)

export default component.exports